import React, { useRef } from "react"
import { useOnClickOutside } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { setActiveModalAction } from "../../action";
import { withRouter  } from 'react-router-dom';
import { modalsSelector } from "../../selectors";
import { sourcesTitlePromo } from "../../constants/app";
import { promocodeAdapter, promoGoodsAdapter } from "../../utils/goods";
import { addToCartPromo, setPromotion } from "../../action/neworder";

const PromotionsModal = () => {
    const ref = useRef();
    const dispatch = useDispatch();
    const availablePromotions = useSelector(modalsSelector).promotionsModal;
    const goodsList = useSelector(state => state.good.list);

    const onClose = () => dispatch(setActiveModalAction({ field: 'promotionsModal', value: null }));

    const onSelect = (promo) => {
        const data = promocodeAdapter(promo);
        if (promo.type === 'addGoods') {
          dispatch(addToCartPromo(promoGoodsAdapter(data.goods, goodsList)));
        }
        dispatch(setPromotion(promocodeAdapter(promo)));
        onClose();
    };
    
    useOnClickOutside(ref, onClose);

    const numberDevider = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    const renderOrder = (promo) => (
        <div className="d-flex mt-3 align-items-center" style={{ fontSize: '1.25rem', color: '#181C32'}}>
          <div style={{ marginRight: '0.5rem' }}>Скидка на заказ</div>
          <div className="text-danger fw-bold" style={{ fontSize: '1.5rem' }}>{`${promo.value}${promo.persent ? '%' : ' ₽'}`}</div>
        </div>
      );

      const renderGood = (goodPromo) => {
        const good = goodsList.find((item) => item.id === goodPromo.value)
        const price = goodPromo.persent ? Math.round(good.price - (good.price * (goodPromo.sale / 100))) : good.price - goodPromo.sale;
        return (
            <>
            <div style={{ borderBottom: '1px solid #EFF2F5', marginTop: '1rem', marginBottom: '1rem'}}></div>
            <div style={{ fontSize: '1.15rem' }}>
                <span style={{ fontWeight: '600' }}>{goodPromo.label}</span>
                <span>{` за ${price} ₽`}</span>
            </div>            
            </>
        )
      };
    
      const renderGoods = (promo) => (
        <div className="mt-3" style={{ fontSize: '1.25rem', color: '#181C32'}}>
          <div style={{ marginRight: '0.5rem' }}>{promo.goods.length === 1 ? 'Скидка на товар:' : 'Скидка на товары:'}</div>
          {promo.goods.map((good) => renderGood(good))}
        </div>
      );
    
      const renderCategory = (promo) => (
        <div className="d-flex mt-3 align-items-center" style={{ fontSize: '1.25rem', color: '#181C32'}}>
          <div style={{ marginRight: '0.5rem' }}>Скидка на категорию {promo.category.label}</div>
          <div className="text-danger fw-bold" style={{ fontSize: '1.5rem' }}>{`${promo.value}${promo.persent ? '%' : ' ₽'}`}</div>
        </div>
      );

      const renderAddGood = (goodPromo) => {
        const good = goodsList.find((item) => item.id === goodPromo.value)
        const price = goodPromo.persent ? Math.round(good.price - (good.price * (goodPromo.sale / 100))) : goodPromo.sale;
        return (
            <>
            <div style={{ borderBottom: '1px solid #EFF2F5', marginTop: '1rem', marginBottom: '1rem'}}></div>
            <div style={{ fontSize: '1.15rem' }}>
                <span style={{ fontWeight: '600' }}>{goodPromo.label}</span>
                <span>{` за ${price} ₽`}</span>
            </div>            
            </>
        )
      };
    
      const renderAddGoods = (promo) => (
        <div className="mt-3" style={{ fontSize: '1.25rem', color: '#181C32'}}>
          <div style={{ marginRight: '0.5rem' }}>{promo.goods.length === 1 ? 'Акционная позиция:' : 'Акционные позиции:'}</div>
          {promo.goods.map((good) => renderAddGood(good))}
        </div>
      );

    const content = (promo) => {
        switch (promo.type) {
            case 'order': return renderOrder(promo);
            case 'goods': return renderGoods(promo);
            case 'category': return renderCategory(promo);
            case 'addGoods': return renderAddGoods(promo);
            default: return null;
        }
    };

    const renderPromotions = (promo) => {
        return (
            <div className="mb-3 border p-3 rounded">
                <h5 style={{ fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.2, color: '#181C32' }}>{promo.name}</h5>
                <div className="d-flex mt-3 align-items-center" style={{ fontSize: '1.15rem', color: '#181C32' }}>
                    <span style={{ marginRight: '0.5rem' }}>Условия: сумма заказа</span>
                    <span className="fw-bold text-danger">{`от ${numberDevider(promo.minPrice)} ₽`}</span>
                </div>
                {content(promo)}
                <div style={{ borderBottom: '1px solid #EFF2F5', marginTop: '1rem', marginBottom: '1rem'}}></div>
                <div className="mt-3">
                    <span style={{ fontSize: '1rem', color: '#181C32' }}> 
                    {`Доступно использование через: 
                    ${promo.sources
                    ? 
                    ` ${promo.sources.split(' ').map((soruce) => sourcesTitlePromo[soruce]).join(', ')}`
                    :
                    ' Все источники'
                    }`}    
                    </span> 
                </div>
                <div className="mt-3">
                    <button onClick={(() => {onSelect(promo)})} type="button" className="btn btn-sm btn-danger">
                    Применить
                    </button>
                </div>
            </div>
        )
    };    

    return(
        <form>
            <div  className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div ref={ref} className="modal-content" style={{ maxWidth: '500px' }}>
                        <div className="modal-header">
                          <div>
                            <h5 className="modal-title"> Акции </h5>
                            {availablePromotions.length > 1 && (
                              <div className="text-muted fw-bold fs-5 mt-3">
                                {`Выберите 1 из ${availablePromotions.length} предложений`}
                              </div>
                            )}
                          </div>
                            <button onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body" style={{ minHeight: '280px' }}>
                            {availablePromotions.map((promo) => renderPromotions(promo))}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default withRouter(PromotionsModal);